import * as Constants from '../constants';
import { triggerAuth } from '../../utilities/blockSdkHelper';
import { default as Endpoint } from '../../api/Endpoint';

export function requestAuthPing() {
  return {
    type: Constants.REQUEST_AUTH_PING
  };
}

export function receiveAuthPing(json, error) {
  return {
    type: Constants.RECEIVE_AUTH_PING,
    data: json,
    error
  };
}

export function triggerAuthInSdk(appId) {
  return () => triggerAuth(appId);
}

export function pingAuth() {
  const path = 'ecs/ping/auth';
  return new Endpoint(path, requestAuthPing, receiveAuthPing)
    .withMethod('GET')
    .withOptions({ ignoreErrors: true })
    .call();
}
